import { useState } from 'react'

const columnaVacia = () => ({ nombre: '', tipo: 'text', nulo: true, pk: false, porDefecto: '' })

/** Alta de tabla. Deliberadamente simple: para lo demás está el editor SQL, que no tiene techo. */
export function NuevaTabla({ tipos, ocupado, error, onCrear }) {
  const [nombre, setNombre] = useState('')
  const [cols, setCols] = useState([{ ...columnaVacia(), nombre: 'id', tipo: 'bigserial', pk: true }])

  const cambiar = (i, campo, valor) =>
    setCols(cols.map((c, j) => (j === i ? { ...c, [campo]: valor } : c)))

  const valida = nombre && cols.length > 0 && cols.every((c) => c.nombre)

  return (
    <div className="card card-pad" style={{ marginBottom: 18 }}>
      <div className="field-label">Nombre de la tabla</div>
      <input className="input" value={nombre} placeholder="pedidos" spellCheck="false"
             style={{ width: 260, fontFamily: 'var(--mono)' }}
             onChange={(e) => setNombre(e.target.value.trim())} />

      <div className="field-label" style={{ marginTop: 16 }}>Columnas</div>
      {cols.map((c, i) => (
        <div className="toolbar" key={i} style={{ marginBottom: 8 }}>
          <input className="input" placeholder="nombre" value={c.nombre} spellCheck="false"
                 style={{ width: 170, fontFamily: 'var(--mono)' }}
                 onChange={(e) => cambiar(i, 'nombre', e.target.value.trim())} />
          <select className="input" value={c.tipo} onChange={(e) => cambiar(i, 'tipo', e.target.value)}>
            {tipos.map((t) => <option key={t}>{t}</option>)}
          </select>
          <input className="input" placeholder="por defecto" value={c.porDefecto} spellCheck="false"
                 style={{ width: 160, fontFamily: 'var(--mono)' }}
                 onChange={(e) => cambiar(i, 'porDefecto', e.target.value)} />
          <label style={{ display: 'flex', gap: 5, alignItems: 'center', fontSize: 13, color: 'var(--fg-2)' }}>
            <input type="checkbox" checked={c.pk} onChange={(e) => cambiar(i, 'pk', e.target.checked)} /> PK
          </label>
          <label style={{ display: 'flex', gap: 5, alignItems: 'center', fontSize: 13, color: 'var(--fg-2)' }}>
            <input type="checkbox" checked={!c.nulo} onChange={(e) => cambiar(i, 'nulo', !e.target.checked)} /> obligatoria
          </label>
          {cols.length > 1 && (
            <button className="btn sm secondary" onClick={() => setCols(cols.filter((_, j) => j !== i))}>–</button>
          )}
        </div>
      ))}

      <div className="toolbar">
        <button className="btn secondary sm" onClick={() => setCols([...cols, columnaVacia()])}>
          Añadir columna
        </button>
        <button className="btn primary" disabled={!valida || ocupado}
                onClick={() => onCrear({ nombre, columnas: cols })}>
          {ocupado ? 'Creando…' : 'Crear tabla'}
        </button>
      </div>
      <div className="field-hint">
        En «por defecto» valen números, <span className="mono">true</span>/<span className="mono">false</span>,
        funciones sin argumentos como <span className="mono">now()</span> o{' '}
        <span className="mono">gen_random_uuid()</span>, y texto, que se entrecomilla solo.
      </div>
      {error && <div className="alert error" style={{ marginTop: 10 }}>{error}</div>}
    </div>
  )
}
